import { Button, InputField } from "../../../components/forms";
import { GoDotFill, GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { SearchBar } from "../../../components/generic/SearchBar";
import { useEffect, useState } from "react";
import { UserItem } from "../../../components/users/UserItem";
import AdduserModal from "../../../components/users/AddUsers";
import { NoDepartment } from "../../../components/users/NoDepartment";
import AddDepartment from "../../../components/users/AddDepartment";
import { useDeptHook } from "../../../hooks/useDeptHook";
import { DepartmentItem } from "../../../components/users/DepartmentIem";
import { NoEmployee } from "../../../components/users/NoEmployee";
import AddEmployee from "../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "./EmployeeItem";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import PersonalInfo from "./PersonalInfo";
import Workinformation from "./Workinformation";
import AddContract from "../../../components/Modules/Employees/AddContract";
import useContractHook from "../../../hooks/useContractHook";
import ContractItem from "./ContractItem";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import useFilePicker from "../../../hooks/useFilePicker";
import { addressRegex, numReg } from "../../../utils/regex";
import { contractTypes, wageTypes } from "../../../constant/data";
import  Datepicker  from "../../../components/generic/Datepicker";
import { FiPlusCircle } from "react-icons/fi";
import DocumentUpload from "../../../components/forms/DocumentUpload";
import { useForm } from "react-hook-form";
import {
  onGetContractDocById,
  onGetContractsById,
  onUpdateContract,
} from "../../../services/contract";
import NavigatebackBtn from "../../../components/generic/NavigateBackBtn";
import Contracts from "./Contracts";

import { FiFileMinus } from "react-icons/fi";
import { Employees } from "./Employees";
import { toast } from "react-toastify";

export default ({ id }: any) => {
  var { control, handleSubmit, watch } = useForm();

  const companypicker = usePickerhook();
  const startdatepick = usePickerhook();
  const enddatepick = usePickerhook();
  const positionPickhook = usePickerhook();
  const contracttypePickhook = usePickerhook();
  const wagetypePickhook = usePickerhook();
  const employeepickHook = usePickerhook();
  const departmentPickhook = usePickerhook();
  const { selectedOrgDepts } = useDepartmentHook();
  const fileuploadhook = useFilePicker();
  const [documents, setdocument] = useState<any[]>([]);
  const { setLoading, setSidebarRenderView } = useStateSetter();
  const watchedFields = watch(["title", "wage"]);
  const { selectedOrgEmployees } = useEmployeeHook();
  const { SelectedOrg, config, authuser } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const [contractdoc, setcontractdocs] = useState([]);
  const [showadddept, setshowadddept] = useState(false);
  const { allorgPositions } = usePositionHook();
  const [entered, setentered] = useState("");
  const tabs = ["All", "Running", "Completed", "Terminated"];
  const tabViews = [<>All</>, <>Running</>, <>Complteted</>];

  const [selectedTab, setselectedTab] = useState(tabs[0]);
  const [selectedTabview, setselectedTabview] = useState(tabViews[0]);

  const [contractDetails, setcontractDetails] = useState<any>({});

  const onSubmit = async () => {};

  const getContractDetails = async () => {
    var res = await onGetContractsById(id, config);

    setcontractDetails(res.data);
  };

  const getContractDocs = async () => {
    var contdocres = await onGetContractDocById(id, config);
    setcontractdocs(contdocres.data);
  };

  useEffect(() => {
    var employee = { name: "", code: "" };
    var dept = { name: "", code: "" };

    selectedOrgEmployees.map((i) => {
      if (i.id == contractDetails.employeeID) {
        employee = { name: `${i.firstName} ${i.lastName}`, code: i.id };
      }
    });
    selectedOrgDepts.map((i) => {
      if (i.id == contractDetails.deptID) {
        dept = { name: i.deptName, code: i.id };
      }
      departmentPickhook.setPickedRole(dept);
    });
    const startdatedateObj = new Date(contractDetails.startDate);
    const enddatedateObj = new Date(contractDetails.startDate);

    employeepickHook.setPickedRole(employee);
    // startdatepick.setPickedRole({name:contractDetails.startDate,code:startdatedateObj})
    // enddatepick.setPickedRole({name:contractDetails.startDate,code:enddatedateObj})
    wagetypePickhook.setPickedRole({
      name: contractDetails.wageType,
      code: contractDetails.wageType,
    });
    contracttypePickhook.setPickedRole({
      name: contractDetails.type,
      code: contractDetails.type,
    });
    positionPickhook.setPickedRole({
      name: contractDetails.position?.positionTitle,
      code: contractDetails.position?.id,
    });
  }, [contractDetails]);

  useEffect(() => {
    getContractDetails();
    getContractDocs();
  }, []);

  const CloseConract = async () => {
    setLoading(true);
    var res = await onUpdateContract({ status: "completed", id:contractDetails.id }, config);
    toast("Contract Closed");
    setLoading(false);
  };
  const ActionItem2 = ({ title }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[tabs.indexOf(title)]);
        setselectedTab(title);
      }}
      className={` m-2 rounded-[8px]    p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs">{title}</p>
    </div>
  );

  const onChange = (e: string) => {
    setentered(e);
  };

  return (
    <div className="w-full pr-20  flex  ">
      {showadddept && <AddContract show={setshowadddept} />}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex items-center justify-between ">
          <div className="flex  flex-col justify-center items-center">
            <NavigatebackBtn
              style={"!inline mr-2  mb-2"}
              onclick={() => {
                setSidebarRenderView(<Contracts />);
              }}
            />
            <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
              {contractDetails.title}
            </p>


            <p className="font-light cursor-pointer inline">
              <GoDotFill className="inline text-green-600" /> {contractDetails.status}
            </p>
          </div>
          <p
            className=" cursor-pointer  text-sm font-semibold mr-2 flex items-center justify-center "
            onClick={ async() => {
CloseConract()
              
              setSidebarRenderView(<Contracts />);
            }}
          >
            <FiFileMinus className="text-primary inline" />
            Close Contract
          </p>
        </div>

        <hr />
        <div className=" flex flex-col      rounded-[8px] bg-white  p-4 ">
          <InputField
            name="title"
            title="Contract title"
            placeholder={"Contract title"}
            defaultvalue={contractDetails.title}
            control={control}
            rules={{
              required: "Contract titleis required",
              pattern: {
                value: addressRegex,
                message: "Invalid Contract title",
              },
            }}
          />
          <div className=" grid grid-cols-2 gap-4  	 ">
            <ListPicker
              fullwidth
              hook={employeepickHook}
              title="Employee"
              list={selectedOrgEmployees.map((i: any) => {
                return { name: `${i.firstName} ${i.lastName} `, code: i.id };
              })}
            />
            <ListPicker
              fullwidth
              hook={contracttypePickhook}
              title="Contract Type"
              list={contractTypes}
            />

            <ListPicker
              fullwidth
              hook={positionPickhook}
              title="Position"
              list={allorgPositions.map((i: any) => {
                return { name: i.positionTitle, code: i.id };
              })}
            />
            <ListPicker
              fullwidth
              hook={departmentPickhook}
              title="Department"
              list={selectedOrgDepts.map((i) => {
                return { name: i.deptName, code: i.id };
              })}
            />

            <Datepicker
              defaultvalue={{
                code: new Date(),
                name: new Date().toDateString(),
              }}
              hook={startdatepick}
              title="Start date"
            />

            <Datepicker
              defaultvalue={{ code: new Date(), name: new Date().toDateString }}
              hook={enddatepick}
              title="End date"
            />

            <ListPicker
              fullwidth
              hook={wagetypePickhook}
              title="Wage Type"
              defaultvalue={{
                name: "contractDetails.wageType",
                code: contractDetails.wageType,
              }}
              list={wageTypes}
            />

            <InputField
              name="wage"
              title="Wage"
              placeholder={"Wage"}
              control={control}
              defaultvalue={contractDetails.wage}
              rules={{
                required: "wage is required",
                pattern: {
                  value: numReg,
                  message: "Invalid wage",
                },
              }}
            />
          </div>
          <div>
            <p className="text flex font-semibold text-gray-600 gap-4  my-3 text-xs">
              Documents{" "}
              <FiPlusCircle className={"inline text-primary"} size={20} />{" "}
              {/* <span
                onClick={() => {
                  setdocument((prev) => prev.concat([""]));
                }}
                className="text-primary text"
              >
                Add
              </span> */}
            </p>
            {documents.map((i: any) => (
              <DocumentUpload hook={fileuploadhook} />
            ))}

            {contractdoc.map((l: any, key: number) => (
              <p className=" font-semibold text-sm ">
                {" "}
                Contract Document {key + 1}
                <a
                  target="_blank"
                  className="text-sm text-primary"
                  href={l.documentURL}
                >
                  {" "}
                  View
                </a>
              </p>
            ))}
          </div>
          {/* <div className=" flex justify-center items-center w-full gap-6">
          

            <Button
              disabled={false}
              text="Save"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};
